import { TablePaginationConfig } from 'antd';
import { DefaultPagination, PageSizeOptions } from 'constants/pagination';

export const DEFAULT_PAGINATION: TablePaginationConfig | false = {
  placement: ['bottomCenter'],
  showSizeChanger: true,
  pageSizeOptions: PageSizeOptions,
  defaultPageSize: DefaultPagination.PAGE_LIMIT,
};
